import React from 'react';
import { SvgIcon } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Link, units } from '@hbf/dsl';
import { Img } from 'ha/ui/Img';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import haLogo from 'ha/img-src/logos/housing-anywhere-logo.svg';
import haLogoUkraine from 'ha/img-src/logos/ha-logo-ukraine.svg';
import HousingAnywhereIcon from 'ha/custom-icons/housing-anywhere-icon.svg';

interface Props {
  showOnlyIcon?: boolean;
  showUkraineFlair?: boolean;
}

const useStyles = makeStyles()(theme => ({
  iconLink: {
    display: 'flex',
  },
  icon: {
    fontSize: units.rem(2.4),
    color: theme.palette.orange.main,
  },
  iconUkraine: {
    color: '#FFD701',
  },
}));

export const NavBarLogo: React.FC<Props> = ({
  showOnlyIcon,
  showUkraineFlair = false,
}) => {
  const { urlResolver } = useIntl();
  const { classes, cx } = useStyles();

  return (
    <Track name="Clicked Logo in header" type="icon">
      <Link
        to={urlResolver.getHomeUrl()}
        className={showOnlyIcon ? classes.iconLink : undefined}
        data-test-locator="HA Logo"
      >
        {showOnlyIcon ? (
          <SvgIcon
            color="secondary"
            className={cx(
              classes.icon,
              showUkraineFlair && classes.iconUkraine,
            )}
          >
            <HousingAnywhereIcon />
          </SvgIcon>
        ) : (
          <Img
            src={showUkraineFlair ? haLogoUkraine : haLogo}
            alt="HousingAnywhere"
          />
        )}
      </Link>
    </Track>
  );
};
